import Header from "./Header";
import Footer from "./Footer";
import Head from "next/head";
import { ServerStyleSheet } from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { KlaviyoPageView, Klaviyo_track_user } from "@/common/Klaviyo";
import { deleteCookie, getCookie, getCookies, setCookie } from "cookies-next";
import { addToCart, updateCart } from "@/redux/actions/addToCartAction";
import { client } from "@/utils/netlify";
import { useRouter } from "next/compat/router";
import { setUserCause } from "@/redux/actions/generalAction";
import { saveUserCharityLocalStorage, updateUserCause, updateCartWhenCharityUpdates, getUserCauseFromLocalStorage } from "@/helpers/charityHelper";
import { resetCart, getNewCheckoutData, updateCheckoutData, removeProductFromCart } from "@/helpers/cartHelpers";
import { generalConstants } from "@/utils/constants";
import { customerLoginData } from "@/helpers/userHelpers";
import { updateUserCheckoutID, updateUserCheckoutIDByEmail } from "@/helpers/userHelpers";
import Script from "next/script";
import { removeTargetAttr, isValidJSON, adjustAccessibilityForApp, getKlaviyoProfile, kustomerJWT } from "@/helpers/generalHelper";
import { setCart, setCustomer } from "./common/Nosto";
import {gaUserToken} from "@/helpers/productHelper";
import { isPWA } from "@/helpers/generalHelper";
import AppLoader from "./PWA/AppLoader.js";
import PageGifLoader from "./PWA/PageGifLoader";
import { getWishlistProducts, mergeUsersWishlist } from "@/helpers/wishlistHelpers";
import { initializeWishlist, wishlistNotInit } from "@/redux/actions/wishlistAction";
import { reportError } from "@/helpers/errorHelper";
import { handleTabIndexingBorderAndClicks } from "@/helpers/adaHelper";
import BackToTopButton from "./BackToTop";
import { getNumberId } from "@/helpers/wishlistHelpers";
import OliPopUp from "@/components/common/OliPopUp";
import { setOliCategory } from "@/redux/actions/oliCategoryAction"; //reduc state to show oli icon 
import GeneralFeedbackIcon from "./common/GeneralFeedbackIcon";

function Layout({ children, footerRef }) {
  const dispatch = useDispatch();
  const router = useRouter();
  const [showLoader, setShowLoader] = useState(false);
  // get the updated user cause from the redux store
  const userCauseValue = useSelector((state) => state.general.user_cause);
  const isPWAApp = useSelector((state) => state.pwa.is_PWA);
  const wc_journey_step = useSelector((state) => state.pwa.welcome_journey.currentStepNo);
  const [kustomerStarted, setKustomerStarted] = useState(false)
  const [isCauseUpdated, setIsCauseUpdated] = useState("")
  const user_cause = useSelector((state) => state.general.user_cause);
  const cart_list = useSelector((state) => state.click.cart_list);
  const [activeTabElement, setActiveTabElement] = useState({ parentElements: [], currentElement: "" });
  const activeTabElementRef = useRef(activeTabElement);
  const oliCategory = useSelector((state) => state.oliCategory.oliCategory); //to hide show oli button
  const handleActiveTab = data => {
    activeTabElementRef.current = data;
    setActiveTabElement(data);
  };

  const discountParam = router.query.olivela_offer ? true : false;
  if (discountParam == true) {
    setCookie(generalConstants.user_discount_tag, true, { maxAge: 86400 });
  }
  let dsnLink =
    "https://" + process.env.ALGOLIA_APPLICATION_ID + "-dsn.algolia.net";
  let gtagLink =
    "https://www.googletagmanager.com/gtag/js?id=" + process.env.GTAG_KEY;
  let klaviyoSRC =
    "//static.klaviyo.com/onsite/js/klaviyo.js?company_id=" +
    process.env.KLAVIYO_KEY;
  let nostoLink = "//connect.nosto.com/include/" + process.env.NOSTO_ACCOUNT_ID;
  let logUser = useSelector((state) => state.loginUser);
  const userId = logUser.userData?.id;
  let customer = logUser?.userData;
  let customerId;
  if (userId) {
    const cId = Buffer.from(userId, "base64").toString("ascii");
    customerId = getNumberId(cId);
  }
  const cause_list = useSelector((state) => state.general.cause_list);
  const resetPassword = router.asPath.includes("password/reset");
  const wishlist_not_init = useSelector((state) => state.wishlist.wishlist_not_init);
  if (router.query.clickId) {
    let click_id = getCookie("utm_clickId");
    if (typeof click_id !== "undefined" && click_id != "") {
      if (click_id != router.query.clickId) {
        setCookie('utm_clickId', router.query.clickId)
      }
    }
    else {
      setCookie('utm_clickId', router.query.clickId)
    }
  }

  var newrelicFile = ''
  if (process.env.APP_MODE == 'production') {
    newrelicFile = '/js/newrelic.js';
  } else if (process.env.APP_MODE == 'stage') {
    newrelicFile = '/js/newrelic_stage.js';
  }

  var forterSiteId;
  var forterFile = ''
  if (process.env.APP_MODE == 'production') {
    forterFile = '/js/forter.js';
    forterSiteId = process.env.FORTER_SITE_ID;
  } else if (process.env.APP_MODE == 'stage') {
    forterFile = '/js/forter_stage.js';
    forterSiteId = process.env.FORTER_STAGE_SITE_ID;
  }

  // if(isPWAApp) {
  //   setCookie("fetched_recommendation", true)
  //   setCookie("recommendations_page_seen", true)
  // }

  // SUP-3457: fix rerendering on url when cause param is present in url
  const handleUpdateUserCause = async (request) => {
    // Update cause in shopify for logged in user
    console.log('updateUserCause layout.js=====')
    const res = await updateUserCause(request);
    if(res) {
      //set the returned cause value from shopify
      const newCause = res?.data?.customerUpdate?.customer?.tags?.find(e=> e.includes("cause:"))
      setIsCauseUpdated(newCause)
    }
  }

  let rakutenSRC = "https://tag.rmp.rakuten.com/" + process.env.RAKUTEN_KEY + ".ct.js";
  useEffect(() => {
    const handleMessage = (event) => {
      // Handle the incoming message
      if(typeof event.data != 'undefined' && typeof event.data != 'object'){
        if(event.data == 'clicked pwaAccount'){
          document.getElementById("pwaAccount").click();
        }else if (event.data == 'clicked pwaShop') {
          document.getElementById("pwaShop").click();
        }else if (event.data == 'clicked pwaHome') {
          document.getElementById("pwaHome").click();
        }else if (event.data == 'clicked pwaDesigner') {
          document.getElementById("pwaDesigner").click();
        }else if (event.data == 'clicked pwaImpact') {
          document.getElementById("pwaImpact").click();
        }
        //OS-5050 guest profile removal
        // else if (event.data.includes("klaviyo external_id set=")) {
        //   const myArray = event.data.split("klaviyo external_id set=");
        //   let klaviyo_external_id=myArray[1]
        //   if(klaviyo_external_id && klaviyo_external_id != "undefined") {
        //     localStorage.setItem("klaviyo_external_id", klaviyo_external_id); 
        //     setKlaviyoIdentifyProfile(klaviyo_external_id)
        //   }
        // }
      }
    };

    window.addEventListener('message', handleMessage);

    KlaviyoPageView(window.location.pathname, window.location);
    if (logUser.userData) {
      KlaviyoPageView(window?.location?.href, logUser?.userData?.email);
    }
    // adding removeTargetAttr() at the layout level from [...pages] file
    removeTargetAttr();
    setShowLoader(true)

    // ADA tab indexing: add border and handle Enter clicks
    document.addEventListener('keydown', (event) => handleTabIndexingBorderAndClicks(event, handleActiveTab, activeTabElementRef));

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener('message', handleMessage);
      document.removeEventListener('keydown', (event) => handleTabIndexingBorderAndClicks(event, handleActiveTab, activeTabElementRef))
    };
  }, []);

  //OS-5050 guest profile removal
  // const setKlaviyoIdentifyProfile = async (klaviyo_external_id) => {
  //   try {
  //     if(!getCookie("userdataToken") && klaviyo_external_id && klaviyo_external_id != "undefined" && !localStorage.getItem('klaviyo_external_profile_id') && !router?.asPath?.includes("/recommended-for-you")) {
  //       let profile = await getKlaviyoProfile(klaviyo_external_id,"external_id")
  //       //OS-5049 object check is added here, as when api returns empty data we get object type response instead of empty string
  //       if(typeof profile != 'object' && profile) {
  //         localStorage.setItem('klaviyo_external_profile_id',profile);
  //         if(typeof klaviyo !== 'undefined' && klaviyo){
  //           klaviyo.identify({'id' : localStorage.getItem('klaviyo_external_profile_id')});
  //           setCookie('klaviyo_profile_identified', "true")
  //         }
  //       } else {
  //         localStorage.setItem('klaviyo_external_profile_id','');
  //       }
  //     }
  //   } catch (error) {
  //   }
  // };

  useEffect(() => {
    //const tokencookie = getCookie("userdataToken")
    // if(tokencookie) {
    //   reportError(`Access token for SUP-3665: ${JSON.parse(tokencookie)?.accessToken}`);
    // } else {
    //   reportError("No Access token found for SUP-3665");
    // }
    const interval = setInterval(() => {
      setTimeout(()=>{
        if(typeof klaviyo !== 'undefined' && klaviyo){
          if (logUser?.userData?.email) {
           klaviyo.identify({'email' : logUser?.userData?.email});
           setCookie('klaviyo_profile_identified', "true")
           clearInterval(interval);
         } else if(localStorage.getItem('klaviyo_external_profile_id')) {
           klaviyo.identify({'id' : localStorage.getItem('klaviyo_external_profile_id')});
           setCookie('klaviyo_profile_identified', "true")
           clearInterval(interval);
         }
       }
      },1000)
    }, 1000);   

    setTimeout(()=>{
      clearInterval(interval); //clear interval in 10 secs
    }, 10000);   

    return () => clearInterval(interval);
  }, [logUser.userLoggedIn]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if(typeof klaviyo !== 'undefined' && klaviyo){
  //        if (logUser?.userData?.email) {
  //         klaviyo.identify({'email' : logUser?.userData?.email});
  //         setCookie('klaviyo_profile_identified', "true")
  //       } else if(localStorage.getItem('klaviyo_external_profile_id')) {
  //         klaviyo.identify({'id' : localStorage.getItem('klaviyo_external_profile_id')});
  //         setCookie('klaviyo_profile_identified', "true")
  //       }
  //     }
  //     }, 2000);
  // },[logUser.userLoggedIn])

  //OS-5050 guest profile removal
  // useEffect(() => {
  //   setTimeout(() => {
  //     setKlaviyoIdentifyProfile(localStorage.getItem('klaviyo_external_id'))
  //   }, 2000);
  // },[wc_journey_step])

  useEffect(() => { //based  on the below patch displath the oli icon show redux state
    if(router && (router.pathname === '/' || router.asPath.includes('/account') || router.asPath.includes('/clothing') || (router.asPath.includes('/designer') && !/\/designer\/.*$/.test(router.asPath)))){
      dispatch(setOliCategory('show'));
    }else if (router && router.asPath.includes('/recommended-for-you')){
      dispatch(setOliCategory(null));
    }
}, [router.asPath, router.pathname]);

  useEffect(()=>{
    //OS-4499
    // Check if Kustomer script is loaded and initialize chat
    const kustomerHandler = () => {
      Kustomer.start({ 
        hideChatIcon: isPWAApp ? true : false,
        zIndex: !isPWAApp && 99,
        brandId: generalConstants.kustomer_brand_id
      },()=> setKustomerStarted(true));
    }
    if(typeof window !== undefined) {
      window.addEventListener('kustomerLoaded',kustomerHandler)
    }
    return () =>{
      window.removeEventListener('kustomerLoaded', kustomerHandler)
    }
  },[kustomerStarted])

  useEffect(()=>{
      //Kustomer login & signup integration
      const kustomerAuthentication = async () => {
        if (logUser?.userLoggedIn) {
          kustomerJWT(logUser?.userData?.email).then((res)=>{
            if (kustomerStarted && typeof window !== undefined && window?.parent?.Kustomer && res) {
              // Use kustomer login function to send JWT to Kustomer
                window?.parent?.Kustomer.login({
                  jwtToken: res
                }, function (_, error) {
                  if (error) {
                    reportError("Kustomer auth error: ",error)
                  } 
                });
                // Check if user is loggedin in Kustomer
                window?.parent?.Kustomer.isLoggedIn({ email: logUser?.userData?.email }, (_, error) => {
                  if (error) {
                    reportError("Kustomer auth error: ",error)
                  }
                });
              }
          }).catch((error)=>{
            reportError("Kustomer auth error: ",error)
          })
          }
      }
      kustomerAuthentication()
  },[kustomerStarted, logUser.userLoggedIn])

  const reintWishlistData = async () => {
    let wish_user = getCookie("WISHLIST_USER_HASH");
    let wish_web = getCookie("WISHLIST_USER_WEB");
    const usersWishlistItems = await getWishlistProducts({HashId: wish_user,timeout:5000})
    let mergedWishlistResponse = await mergeUsersWishlist(wish_web,wish_user,usersWishlistItems,5000);
    const testAgainWishlistItems = await getWishlistProducts({HashId: wish_user,timeout:5000})
    if (mergedWishlistResponse) {
      sessionStorage.setItem(
        "wishlist",
        JSON.stringify({ items: testAgainWishlistItems })
      );
      dispatch(
        initializeWishlist({
          wishlistHashId: wish_user,
          wishlist: testAgainWishlistItems,
        }))
    }
    dispatch(wishlistNotInit(false))

  }

  useEffect (() => {
    if(wishlist_not_init) {
      reintWishlistData()
    }
  },[wishlist_not_init])

  //  CART LOGIC
  const fetchUserCart = async () => {
    try {
      //OS-4874 now the cart is empties automatically on complete no need of manual emptying
      let cookie_initial_checkout = getCookies().cookie_initial_checkout;
      if (
        typeof localStorage.getItem("pwacheckoutId") != "undefined" && cookie_initial_checkout === "redo"
      ) {

        // const checkoutId = getCookie("checkoutId");
        const pwaCheckoutId = localStorage.getItem("pwacheckoutId")
        setCookie("cookie_initial_checkout", "done"); //set it to done so that cart does not get fetched again and again
        // if (checkoutId) {
        //   getCheckoutData(decodeURIComponent(checkoutId));
        // } else {
          getCheckoutData(decodeURIComponent(pwaCheckoutId));
        // }
      }
      else if (
        typeof localStorage.getItem("pwacheckoutId") === "undefined" && getCookie("userdataToken") && typeof getCookie("dont_fetch_cart") === "undefined"
      ) {

        let cookie_data = JSON.parse(getCookie("userdataToken"));
        if(cookie_data != null){
          const userData = await customerLoginData({
            token: cookie_data.accessToken,
          });
        }
        if (typeof userData != 'undefined' && userData?.customer?.checkout_id?.value && userData.customer.checkout_id.value != "NA") {
          // setCookie("checkoutId", userData.customer.checkout_id.value);
          localStorage.setItem("pwacheckoutId", userData?.customer?.checkout_id?.value);
          getCheckoutData(decodeURIComponent(userData?.customer?.checkout_id?.value));
        }
      }
    } catch (e) {
      reportError("Error fetching user cart");
      reportError(e.stack)
    }
  };

  //OS-4874 no need of deleteCompletedCheckout function as cart is emptied automatically

  const getCheckoutData = async (checkoutId) => {
    try {
      if (!checkoutId) {
        sessionStorage.setItem("cart_list", null);
        setCookie("cookie_present", "true");
        // deleteCookie("checkoutId");
        return null;
      }
      let response = await client("get-checkout-data", { id: checkoutId });
      //OS-4874 no need of deleteCompletedCheckout function as cart is emptied automatically
      sessionStorage.setItem("cart_list", JSON.stringify(response));
      setCookie("cookie_present", "true");
      dispatch(addToCart(response));
    } catch (error) {
      reportError("Error in getCheckoutData");
      reportError(error.stack)
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      resetCart();
      // const initialCheckoutId = getCookie('checkoutId');
      const pwaCheckoutId = localStorage.getItem('pwacheckoutId');
      // if (initialCheckoutId) {
      //   await getCheckoutData(initialCheckoutId);
      // } else
      if (pwaCheckoutId) {
        await getCheckoutData(pwaCheckoutId);
      }
      // if (getCookie('compareCheckout')) {
      //   updateCheckoutData(getCookie('new_checkoutId'), getCheckoutData);
      // }
      if (typeof getCookie('cookie_initial_checkout') === 'undefined') {
        setCookie('cookie_initial_checkout', 'redo');
      }
      await fetchUserCart();
    };
    fetchData();
    
  },[logUser.userLoggedIn]);
  
  useEffect(() => {
    //set the algolia userToken at the start, once set it will be passed to all the events
    gaUserToken();
    if (logUser.userData) {
      //get userid
      const nostoUserId = logUser.userData.id;
      Klaviyo_track_user(logUser.userData);
      //nosto api call to set current user
      setCustomer(nostoUserId);
    }
    else {
      setCustomer(null);
    }
    //OS-3262 : precheckout recommendation - to handle case if cart is prepopulated from previous session
    var cartData = JSON.parse(sessionStorage.getItem("cart_list"));
    if (cartData) {
      // setCart(cartData);
    }
    removeTargetAttr();
    //OS-5050 guest profile removal
    // if(!getCookie("userdataToken") && (!(localStorage.getItem('klaviyo_external_id') && localStorage.getItem('klaviyo_external_id') != "undefined"))) {
    //   window?.ReactNativeWebView?.postMessage(JSON.stringify({message: "set klaviyo external id"}));
    // }

    // if(!getCookie("userdataToken") && localStorage.getItem('klaviyo_external_id') && localStorage.getItem('klaviyo_external_id') != "undefined") {
    //   alert("code to cross check external id")
    //   window?.ReactNativeWebView?.postMessage(JSON.stringify({message: "cross check klaviyo external id","token":localStorage.getItem('klaviyo_external_id')}));
    // }
  },[]);

  useEffect(() => {
      // Set user cause if cause is added in query parameter. eg. www.olivela.com/women?cause=stc
      var userCause = router.query?.cause?.toLowerCase();
      //get usercause from localstorage or the redux state
      var userCauseFromLocal;
      if(userCauseValue){
        userCauseFromLocal = userCauseValue;
        /**
         * when URL changes, the redux store is reset and gets the stringify value of user cause from local storage as initial state.
         * This initial redux value needed to be parsed back for further calculations.
         */
        try{
          if(isValidJSON(userCauseFromLocal)){
            userCauseFromLocal = JSON.parse(userCauseFromLocal);
          }
        }
        catch(e){
          console.log(e)
        }
      }
      else{
         userCauseFromLocal = JSON.parse(localStorage.getItem("user_cause"));
      }

      //SUP-2788 : Condition when cause is not added in query parameter & cause is inactive, assign site_default value to user cause
    if (typeof userCause == 'undefined' ) {
      if (cause_list && cause_list != null) {
        var siteDefault = cause_list.find(
          (cause) => (cause.site_default == 1)
        );
        var cause = cause_list.find(
          (causeVal) => (causeVal.short_code === userCauseFromLocal && causeVal.active == 1)
        );
        if (cause) {
          userCause = cause.short_code;
        }
        else {
          userCause = siteDefault;
        }
      }
    }
    if (userCause) {
      if (cause_list && cause_list!=null) {
        var cause = cause_list.find(
          (causeVal) => (causeVal.short_code === userCause && causeVal.active == 1)
        );

        if (typeof cause == 'undefined') {
          var cause = cause_list.find(
            (causeVal) => (causeVal.active == 1 && causeVal.site_default == 1)
          );
          userCause = cause.short_code;
        }
        let request = {}
        if (cause) {
          request.cause = cause.short_code
          //Update cause realted custom attribute for cart line items
          updateCartWhenCharityUpdates(userCause, cause_list);
          var updatedCartList = JSON.parse(sessionStorage.getItem("cart_list"));
          //get current local storage cause before we update the new cause
          let localCause = getUserCauseFromLocalStorage();
          dispatch(updateCart(updatedCartList));
          saveUserCharityLocalStorage(userCause);
          dispatch(setUserCause(userCause));
          // If user is logged in, then update cause in shopify else localstorage only
          if(logUser.userLoggedIn){
            // debugger;
            if(request.cause != localCause){
              console.log('updateUserCause localCause=====')
              handleUpdateUserCause(request)
            }
          } else {
            setIsCauseUpdated(cause.short_code)
          }
        }
      }
    }
    //OS-3879: Headless login sync
    // if(logUser?.userLoggedIn && router?.asPath?.includes("/account/login")) {
    //   if(typeof window !== undefined && document.getElementById("checkoutButton") && (document.referrer?.includes("qacheckout.olivela.com") || document.referrer?.includes("checkout.olivela.com"))) {
    //     document.getElementById("checkoutButton")?.click()
    //   }
    // }
  }, [logUser.userLoggedIn, router.query.cause, cause_list]);

  useEffect(()=> {
    // SUP-3312: removing cause params from url once cause is set in headless
    const localCause = JSON.parse(localStorage.getItem("user_cause"));
    if(router?.query?.cause && localCause === router?.query?.cause && isCauseUpdated?.includes(router?.query?.cause) ){
      const { cause , ...routerQuery } = router.query;
      router.replace({
        query: { ...routerQuery },
      });
      setIsCauseUpdated("")
    }
  },[isCauseUpdated,user_cause])

  useEffect(() => {
    //using session storage as we need to record the landing page event only once per session 
    const sessionKey = 'effectHasRun';
    const hasEffectRun = sessionStorage.getItem(sessionKey);

    //hide accessibility icon and shift down accessbility drawer for iphone
    if(isPWAApp){
      adjustAccessibilityForApp();
      //recording landing pages for the app
      if(!hasEffectRun) {
          dataLayer.push({ 'event': 'app_landing_page',
          'app_landing_page_url': window.location.href ,
          });
      }
    }
    sessionStorage.setItem(sessionKey, 'true');
  }, [])

  useEffect(()=>{
    // since we have removed footer from app, adding additional padding to adjust screen
    if(typeof document !== undefined){
      let body = document.body;
      if (router && router.pathname !== '/recommended-for-you') {
        if(wc_journey_step == 6){
          body.classList.add("addPaadingBottomToAPP")
        }
      }
      if(isPWAApp){
        body.classList.add("pwaClass")
      }
    }
  },[wc_journey_step])

  return (
    <>
      <Head>
        <link crossOrigin href={dsnLink} rel="preconnect" />
        {/* Builderscript added to disable builder preview links tracking in GA4 */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
	            function exclude_ga(){
                var urlParts = new URL(window.location.href);
                if(urlParts.searchParams.get('__builder_editing__')){
                  window['${process.env.MEASUREMENT_ID}'] = true;         
                }
              }
              exclude_ga();`,
          }}
        ></script>

        {/* nosto script for the app */}
        {isPWAApp && (
          <script dangerouslySetInnerHTML={{
            __html: `if (window.navigator.userAgent.indexOf("PWAShell") > -1) {
              nostojs(function (api) { api.addSegmentCodeToVisit("PWAShell") }) ;
            }`}}> </script>
        )}

        {/* Global site tag (gtag.js) - Google Analytics */}
        {/* <script async src={gtagLink}></script>
                <script
                    dangerouslySetInnerHTML={{
            __html: `
                    window.dataLayer = window.dataLayer || [];
	                function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', ${process.env.GTAG_KEY});
                  
                    `,
          }}
        /> */}
        {/* <script async src={gtagLink}></script>  */}

        {/* error reporting script */}
        <script async type="text/javascript" src={newrelicFile} />

        {/* <script
          dangerouslySetInnerHTML={{
            __html: `
                    window.dataLayer = window.dataLayer || [];
	                function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config','${process.env.GTAG_KEY}',
                    'linker': {
                      'domains': ['qa.olivela.com', 'qacheckout.olivela.com','olivelastaging.myshopify.com','*.shop.app','*.paypal.com','*.google.com']
                    }
                    );
                    //this is for Littledata tracking
                    gtag('config', '${process.env.LITTLEDATA_KEY}')
                     
                    `,
          }}
        /> */}
        {/* <!-- AnalyticsJS - Segment.com --> */}
        {/* <script
          dangerouslySetInnerHTML={{
            __html: `
!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
analytics.load("1MTr5E0mmf92XtjsOhAmPWHq6D8aHBGC");
analytics.page();
}}()`,
          }}
        /> */}
        {/* <!-- SETUP FOR klaviyo start --> */}

        <script
          async
          type="text/javascript"
          src={klaviyoSRC}

        ></script>
        {/* <!-- SETUP FOR klaviyo end --> */}


        {/* <!-- Google Tag Manager --> */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${process.env.GTM_KEY}');
    `,
          }}
        ></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
                (() => {window.nostojs=window.nostojs||(cb => {(window.nostojs.q=window.nostojs.q||[]).push(cb);});})();
                  `,
          }}
        ></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
                    nostojs(api => api.setAutoLoad(false));
                  `,
          }}
        ></script>
        <script src={nostoLink} async></script>

        {/* <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        ></meta> */}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <meta name="apple-mobile-web-app-title" content="Olivela"></meta>
        <meta name="apple-mobile-web-app-capable" content="yes"></meta>
        <meta name="apple-mobile-web-app-external-link" content="yes"></meta>
        <meta name="apple-itunes-app" content="app-id=6498630359" />
        {/* <meta name="theme-color" content="#C5D3E2" /> */}
        {/* <meta name="theme-color" content="#009e99"></meta> */}
        {/* <meta name="apple-mobile-web-app-status-bar-style" content="black"></meta>  */}
        {/* jquery call used for nosto - SUP-3808 */}
        <script
          async
          type="text/javascript"
          src="/js/jquery.min.js"></script>
        {/**/}
        <script type="text/javascript" id={forterSiteId} src={forterFile} async></script>
        {process.env.APP_MODE == 'production' && <script
          async
          type="text/javascript"
          src={rakutenSRC}></script>}
        {/*  Start of VWO Async SmartCode */}
        <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
        <script id = "vwoCode" strategy="beforeInteractive"
          dangerouslySetInnerHTML={{
            __html: `
           
            window._vwo_code || (function() {
            var account_id=${process.env.VWO_ACC_ID},
            version=2.0,
            settings_tolerance=2000,
            hide_element='body',
            hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
            /* DO NOT EDIT BELOW THIS LINE */
            f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){w._vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){w._vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();(function(){var i=window;function t(){if(i._vwo_code){var e=t.hidingStyle=document.getElementById('_vis_opt_path_hides')||t.hidingStyle;if(!i._vwo_code.finished()&&!_vwo_code.libExecuted&&(!i.VWO||!VWO.dNR)){if(!document.getElementById('_vis_opt_path_hides')){document.getElementsByTagName('head')[0].appendChild(e)}requestAnimationFrame(t)}}}t()})();
            
            `,
          }}
        ></script>
        {/*  End VWO Async SmartCode */}

        {/* <!-- Pinterest pixel --> */}
        { (process.env.NETLIFY_URL != "https://www.olivela.com") &&
          <script
            dangerouslySetInnerHTML={{
              __html: `
          !function(e){if(!window.pintrk){window.pintrk=function()
            {window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
            n=window.pintrk;n.queue=[],n.version="3.0";var
            t=document.createElement("script");t.async=!0,t.src=e;var
            r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}
            ("https://s.pinimg.com/ct/core.js"); 
            
            pintrk('load','2612982584334', { em: '${logUser?.userData?.email}', });
            pintrk('page');
          `,
            }}>
          </script> }
        {/* <!-- End Pinterest pixel Code --> */}
      </Head>
      {/* Load yotpo script for campaign points and tiers */}
      <Script src={`https://cdn-loyalty.yotpo.com/loader/${process.env.YOTPO_REWARDS_JS_ID}`} />

      {router && router.pathname !== '/recommended-for-you' && <Header />}
      {router && router.pathname === '/recommended-for-you' && <div className="d-none"><Header /></div>}
      <main className={`${resetPassword ? "reset-password-class" : ""} ${router.pathname === '/your-bag' ? "you_bag_class" : ""}`}>{children}</main>
      {router && router.pathname === '/' &&
        <Script src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${process.env.YOTPO_REWARDS_JS_ID}`} />
      }
      { 
          userId && <div id="swell-customer-identification" data-authenticated="true"
          data-email={customer.email}
          data-id={customerId}
          data-tags={JSON.stringify(customer.tags)}
          style={{ display: 'none' }}>
        </div>
      }
      {router && router.pathname !== '/recommended-for-you' &&
        <Footer footerRef={footerRef} />}
      {/* <WelcomeLoader /> */}
      {/* this component is used to show the loader when the home page is loading */}
      {/* to fix the CLS issue */}
      {/* {<AppLoader/>} */}
      {showLoader && <PageGifLoader/>}
      
      {isPWAApp && <BackToTopButton/>}
      {oliCategory && <OliPopUp/> }
      {/* <GeneralFeedbackIcon/> */}

      {/* <!--Loads Kustomer Chat --> */}
      <Script
        defer
        src="https://cdn.kustomerapp.com/chat-web/widget.js"
        data-kustomer-api-key={generalConstants.kustomer_api_key}
      />

      {/* <!--Attentiev Enhanced Tag --> */}
      <Script 
        async
        type="text/javascript"
        src="https://damcd.olivela.com/providers/atLabel/load"
        onError={()=>{
          const fallbackScript = document.createElement('script');
          fallbackScript.src='https://cdn.attn.tv/olivela/dtag.js';
          document.head.appendChild(fallbackScript)
        }}
      />
    </>
  );
}

Layout.getInitialProps = async (ctx) => {
  const sheet = new ServerStyleSheet();
  const originalRenderPage = ctx.renderPage;

  try {
    ctx.renderPage = () =>
      originalRenderPage({
        enhanceApp: (App) => (props) => sheet.collectStyles(<App {...props} />),
      });

    const initialProps = await Document.getInitialProps(ctx);
    return {
      ...initialProps,
      styles: (
        <>
          {initialProps.styles}
          {sheet.getStyleElement()}
        </>
      ),
    };
  } finally {
    sheet.seal();
  }
};

export default Layout;
